<template>
  <UsuariosExtLayout>
    <template #header>
      <div class="conecta-page__header-bg" aria-hidden="true"></div>
      <div class="conecta-page__header-content">
        <div class="conecta-page__brand">
          <div class="conecta-page__logo">
            <img
              src="/img/Logo-STS.png"
              alt="Conecta Sabana"
              class="conecta-page__logo-img"
            />
          </div>
          <div class="conecta-page__brand-text">
            <span class="conecta-page__eyebrow">Portal de autoservicio</span>
            <h1 class="conecta-page__title">Conecta Sabana</h1>
            <p class="conecta-page__subtitle">
              <i class="fas fa-bolt conecta-home__slogan-icon" aria-hidden="true"></i>
              Mueve tu mundo, todo en un clic
            </p>
          </div>
        </div>
        <p class="conecta-page__intro">
          Gestiona tu tarjeta de transporte de forma digital, rápida y segura.
          Elige una acción para comenzar.
        </p>
      </div>
    </template>

    <section class="conecta-home__actions" aria-label="Acciones disponibles">
      <h2 class="conecta-home__section-title">
        <i class="fas fa-th-large mr-2"></i>
        ¿Qué deseas hacer hoy?
      </h2>
      <div class="conecta-home__grid">
        <CardAction
          v-for="(action, index) in actions"
          :key="action.id"
          :title="action.title"
          :description="action.description"
          :icon="action.icon"
          :route="action.route"
          :gradient-start="action.gradientStart"
          :gradient-end="action.gradientEnd"
          :delay="staggerDelay(index)"
          @navigate="navigateTo"
        />
      </div>
    </section>
  </UsuariosExtLayout>
</template>

<script>
import CardAction from "../../components/usuariosExt/CardAction.vue";
import UsuariosExtLayout from "../../components/usuariosExt/UsuariosExtLayout.vue";

export default {
  name: "ConectaSabanaHome",

  components: {
    CardAction,
    UsuariosExtLayout,
  },

  data() {
    return {
      actions: [
        {
          id: "recargar",
          title: "Recargar tarjeta",
          description: "Añade saldo a tu tarjeta de forma inmediata y segura.",
          icon: "fas fa-wallet",
          route: "/epayco",
          gradientStart: "#05A85A",
          gradientEnd: "#8FC74B",
        },
        {
          id: "actualizar-datos",
          title: "Actualizar datos tarjeta",
          description: "Modifica tu información personal asociada a la tarjeta.",
          icon: "fas fa-user-edit",
          route: "/DatosTarjetasForm",
          gradientStart: "#61A198",
          gradientEnd: "#92C0B4",
        },
        {
          id: "comprar",
          title: "Comprar tarjeta",
          description: "Solicita una nueva tarjeta de transporte digital.",
          icon: "fas fa-shopping-cart",
          //route: "/usuarios-ext/comprar-tarjeta",
          route: "/usuarios-ext/comprar-tarjeta111",
          gradientStart: "#8FC74B",
          gradientEnd: "#D1E29B",
        },
       /*  {
          id: "bloquear",
          title: "Bloquear tarjeta",
          description: "Protege tu saldo bloqueando la tarjeta por pérdida o robo.",
          icon: "fas fa-lock",
          route: "/usuarios-ext/bloquear-tarjeta",
          gradientStart: "#61A198",
          gradientEnd: "#05A85A",
        }, */
        {
          id: "reposicion",
          title: "Reposición tarjeta",
          description: "Solicita el reemplazo de tu tarjeta dañada o extraviada.",
          icon: "fas fa-exchange-alt",
          //route: "/usuarios-ext/reposicion-tarjeta",
          route: "/usuarios-ext/reposicion-tarjeta111",
          gradientStart: "#92C0B4",
          gradientEnd: "#B2D5BE",
        },
        {
          id: "consultar-solicitudes",
          title: "Consultar estado de solicitudes",
          description: "Revisa el avance de tus trámites y peticiones en línea.",
          icon: "fas fa-clipboard-check",
          route: "/usuarios-ext/consultar-solicitudes",
          gradientStart: "#05A85A",
          gradientEnd: "#61A198",
        },
      ],
    };
  },

  methods: {
    staggerDelay(index) {
      return 80 + index * 90;
    },

    navigateTo(route) {
      this.$router.push(route);
    },
  },
};
</script>

<style scoped lang="scss">
$green-light: #8fc74b;

.conecta-home__slogan-icon {
  font-size: 0.8rem;
  color: $green-light;
}

.conecta-home__section-title {
  margin: 0 0 1.5rem;
  font-size: 1.15rem;
  font-weight: 600;
  color: #1a3d2e;
}

.conecta-home__grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
}

@media (min-width: 576px) {
  .conecta-home__grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.25rem;
  }
}

@media (min-width: 992px) {
  .conecta-home__grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 1.5rem;
  }
}
</style>
